import React from 'react';
import ModalCloseIcon from '@/components/general/ModalCloseIcon/ModalCloseIcon';
import { FlexContainer } from '@/components/containers/FlexContainer/FlexContainer';
import Label from '@/components/form/Label/Label';

const ConfirmacionCitaModal2 = ({ open, onClose, loadingSaveHistory }) => {
  if (!open) return null;

  return (
    <FlexContainer
      className={'pos-fixed justify-center align-items-center'}
      style={{
        inset: 0,
        background: 'rgba(0,0,0,0.45)',
        zIndex: 9999,
      }}
    >
      {loadingSaveHistory && (
        <>
          <div
            style={{
              position: 'absolute',
              inset: 0,
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              background: 'rgba(255,255,255,0.7)',
              zIndex: 10,
              borderRadius: '10px',
            }}
          >
            <div className="spinner" />
          </div>
        </>
      )}
      {!loadingSaveHistory && (
        <FlexContainer
          className={'pos-rel flex-column align-center width-600px padtb36 padlr36 m-format75'}
          style={{
            background: '#ffffff',
            borderRadius: '6px 6px 6px 6px',
            boxShadow: '0px 5px 18px rgba(0,0,0,0.18)',
          }}
        >
          <FlexContainer
            onClick={onClose}
            className={
              'pos-abs top20 right20 pointer width-34px height-34px align-items-center justify-center text-18 fontWhite'
            }
            style={{
              borderRadius: '50%',
              background: '#023B7A',
              fontWeight: '900',
              boxShadow: '0px 2px 5px rgba(2, 59, 122, 0.3)',
            }}
          >
            <ModalCloseIcon />
          </FlexContainer>

          <div
            className={
              'width-520px m-format72 height-420px bgWhite borderrad20 padtb20 padlr12 pos-rel top16  left30'
            }
          >
            {' '}
            <Label className={'text-18 font-bold text-center margt60'} style={{ color: '#023B7A' }}>
              <strong>Agendamiento exitoso</strong>
            </Label>
            <Label
              className={'text-18 font-medium margt10 text-center'}
              style={{fontWeight: 'bold', backgroundColor: '#FFF3CD', padding: '8px 10px', borderRadius: '6px', marginBottom: '8px', listStyle: 'none', marginLeft: '-16px' }}
            >
                Esta cita debe ser pagada en un plazo no mayor a 48 horas, para evitar que la
                reserva sea cancelada
            </Label>
            <FlexContainer
              className={
                'justify-center align-center margl160 m-margl20 margt28 pos-rel width-180px height-180px'
              }
              style={{
                borderRadius: '50%',
                border: '4px solid #023B7A',
              }}
            >
              <FlexContainer
                className={
                  'justify-center align-center flex-column margt14 width-140px height-140px '
                }
                style={{
                  borderRadius: '50%',
                  background: '#6f8ec0',
                  padding: '5px',
                }}
              >
                <Label className={'text-20 font-semibold text-center'} style={{ color: '#023B7A' }}>
                  <strong>¡Gracias!</strong>
                </Label>

                <Label
                  className={'text-14 text-center margt6'}
                  style={{
                    color: '#023B7A',
                    lineHeight: '1.4',
                    fontWeight: 600,
                  }}
                >
                  Tu cita ha sido
                  <br />
                  agendada con <br />
                  éxito.
                </Label>
              </FlexContainer>

              <FlexContainer
                className={
                  'justify-center align-center width-40px height-40px right0 bottom4 pos-abs'
                }
                style={{
                  borderRadius: '50%',
                  background: '#023B7A',
                  border: '4px solid #ffff',
                }}
              >
                <span
                  className={'text-24 fontWhite margt8'}
                  style={{ fontWeight: 900, lineHeight: 1 }}
                >
                  <strong>✓</strong>
                </span>
              </FlexContainer>
            </FlexContainer>
            {/*  <Label
            className={'text-14 padlr50 margt28 text-center'}
            style={{
              color: '#4B4B4B',
              width: '80%',
              lineHeight: '1.4',
            }}
          >
            Podrás ver todos los detalles en la sección{' '}
            <strong>mi historial de citas</strong>.
            <br />
            ¡Evita demoras! Paga tu cita ahora en nuestra Web.
          </Label> */}
          </div>
        </FlexContainer>
      )}
    </FlexContainer>
  );
};

export default ConfirmacionCitaModal2;
